module.exports = __webpack_public_path__ + "static/media/contrast-dark-logo.e2e3d4b8.png";